import { StateReportSubmitScreen } from "app/screens/residents/show/StateReportSubmitScreen";

export default function ResidentAddStateReportPage() {
  return <StateReportSubmitScreen />;
}
